module.exports = __webpack_public_path__ + "img/slide-3.8051fcd9.png";